import { Space } from 'api/space';

export type EditSpaceTypes = {
  space: Space;
  onChange: (space: Space) => void;
  onCancel: (space: Space) => void;
  isLoading?: boolean;
};

export enum KeyCodes {
  Esc = 27,
}
